export const RiseWordmark = ({ className = "text-5xl", testid = "rise27-wordmark" }) => (
  <span
    data-testid={testid}
    className={`inline-flex items-baseline gap-[0.15em] font-display font-black uppercase leading-[1] tracking-tight text-white ${className}`}
  >
    RISE <span className="text-neon">27'</span>
  </span>
);

export const StarField = ({ className = "" }) => (
  <div
    aria-hidden="true"
    className={`pointer-events-none absolute inset-0 ${className}`}
    style={{
      backgroundImage:
        "radial-gradient(1.4px 1.4px at 18% 24%, rgba(255,255,255,0.85) 50%, transparent 51%)," +
        "radial-gradient(1.6px 1.6px at 72% 16%, rgba(255,255,255,0.7) 50%, transparent 51%)," +
        "radial-gradient(1.2px 1.2px at 41% 62%, rgba(255,255,255,0.6) 50%, transparent 51%)," +
        "radial-gradient(1.8px 1.8px at 86% 71%, rgba(204,255,0,0.55) 50%, transparent 51%)," +
        "radial-gradient(1.2px 1.2px at 9% 81%, rgba(255,255,255,0.55) 50%, transparent 51%)," +
        "radial-gradient(1.5px 1.5px at 57% 88%, rgba(255,255,255,0.5) 50%, transparent 51%)," +
        "radial-gradient(900px 520px at 15% 10%, rgba(40,78,140,0.35), transparent 70%)," +
        "radial-gradient(700px 420px at 88% 85%, rgba(24,52,102,0.4), transparent 70%)",
    }}
  />
);
